// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"e52b67111e44ab45","61":"d5ae03466ff577ab","253":"9d93e4c7de7c0de4","626":"60199cc71ef0c6fa","860":"8fec01ca82592986"}[chunkId] + ".js";
};